import { AfterViewInit, Component, OnInit } from "@angular/core";
import { NavigationSmallUtils } from "sharedGuiSmall/utils/navigation-utils";
import { Account } from "sign-up-app/model/account";
import { AuthAppService } from "sign-up-app/services/auth.service";
import { Router } from "@angular/router";
import { currencySymbols, currencyUtcSymbols, LicenseFrequency, LicensePackageOptions, LicensePackageType, LicenseStatus } from "sharedGuiSmall/enums";
import { CurrencyGeoData } from "sharedGuiSmall/utils/currencyData";
import { Utils } from "sharedGuiSmall/utils/utils";
import { NavigationUtils } from "sharedFeatures/utils";

@Component({
    selector: 'payment-form',
    templateUrl: './payment-form.component.html',
    styleUrls: ['./payment-form.component.less']
})

export class PaymentFormComponent implements OnInit, AfterViewInit {

    private accountData: Account = new Account();

    fullUrl: string = window.fullLiveUrl;

    productVersion: string = '2.0';
    buttonText = $localize `Buy `;

    selectedCurrency: string = 'GBP';
    currentCurrencySymbol: string = '£';
    currentPriceMonthly: string = '19';
    currentPriceAnnually: string = '30';
    packageType: string = LicensePackageType.BrixxSingle;
    frequency: string = LicenseFrequency.Monthly

    returnLinkForm: string = 'sign-up/foundation';

    currencySymbols = currencyUtcSymbols; 
    
    prices: Record<string, string[][]> | undefined= undefined;

    monthlyPlan: boolean = true;
    annuallyPlan: boolean = false;

    isAlternativePrice: boolean = false;

    package: string = '';
    licenseType: string = LicensePackageType.BrixxSingle;

    isBusiness: boolean = false;
    isEssentials: boolean = false;
    isProfessionals: boolean = false;

    userGeo = Utils.getNavigatorLanguage().replace(/-/g, '_');

    isBusinessDoctors: boolean = false;

    constructor(private authService: AuthAppService, private router: Router) {
        this.isBusinessDoctors = (String)(window['isBusinessDoctors']).toLowerCase() === 'true';
    }

    ngOnInit(): void {
        if (!this.authService.isSpinnerHidden) {
            this.authService.toggleSpinner();
        }
    }

     ngAfterViewInit(): void {
        
         this.getPackageType();
        
         this.selectedCurrency = CurrencyGeoData.getGeoBasedCurrency(this.userGeo);
         let currency = currencyUtcSymbols.find(currency => currency.value == this.selectedCurrency)?.value;
         
         if (currency !== undefined){
             this.authService.GetPricesTable(NavigationUtils.productCode).then(data => {
                 this.prices = JSON.parse(data.prices);
                 this.selectCurrency(currency!);
             })
         }
         
         this.authService.getAccountDataMiddleware();
    }

    getBrixxStartUrl() {
        return this.fullUrl + 'brixx-start';
    }

    goToPayment() {
        this.accountData = this.authService.Account;
        NavigationSmallUtils.openPaymentPage(
            this.accountData,
            this.packageType,
            this.frequency,
            this.selectedCurrency,
            this.getBrixxStartUrl(),
            this.isAlternativePrice,
            this.productVersion,
            this.accountData.subscriptionRef
        );
    }

    selectPricePlan(priceId: number) {
        switch (priceId) {
            case 0:
                this.frequency = LicenseFrequency.Monthly;
                this.monthlyPlan = true;
                this.annuallyPlan = false;
                break;
            case 1:
                this.frequency = LicenseFrequency.Annually;
                this.monthlyPlan = false;
                this.annuallyPlan = true;
                break;
        }
    }


    private getNameLicense(packageType: string): void {
        switch (packageType) {
            case LicensePackageOptions.get(LicensePackageType.BrixxSingle)!.OptionName:
                this.licenseType = LicensePackageType.BrixxSingle;
                break;
        }
    }

    private getFindPackage(packageType: string): string | undefined {
        this.getNameLicense(packageType);

        const licenses = [LicensePackageType.BrixxSingle];

        for (let i = 0; i < licenses.length; i++) {
            if (String(this.licenseType).includes(licenses[i]) && this.licenseType != LicenseStatus.Trial) {
                this.licenseType = licenses[i];
                return LicensePackageOptions.get(licenses[i])!.OptionName;
            }
        }

        this.router.navigate([this.returnLinkForm], { skipLocationChange: false });
    }

    getPackageType() {
        let packageType: string | null = localStorage.getItem('packageTypeRegistration');
        if (packageType === null)
            return;

        const _package: string | undefined = this.getFindPackage(packageType);
        if (_package === undefined)
            return;

        this.package = _package;
        this.buttonText += this.package;

        switch (this.licenseType) {
            case LicensePackageType.BrixxSingle:
                this.packageType = LicensePackageType.BrixxSingle;
                break;
        }
    }

    selectCurrency(currency: string): void {
        this.selectedCurrency = currency;
        const currencyId = currencyUtcSymbols.find(cur => cur.value == currency)!.id;
        this.currentCurrencySymbol =  this.getCurrencySymbolOrDefault(currencyId, this.currentCurrencySymbol);
            
        let packageType: string | null | undefined = localStorage.getItem('packageTypeRegistration');
        if (packageType !== null)
            packageType = this.getFindPackage(packageType);

        if (packageType !== null && packageType !== undefined && this.prices !== undefined) {
            switch (packageType) {
                case LicensePackageOptions.get(LicensePackageType.BrixxSingle)!.OptionName:
                    this.currentPriceMonthly = this.prices[currency][0][2];
                    this.currentPriceAnnually = this.prices[currency][1][2];
                    break;
                }
            }
        
        for(let i = 0; i < currencyUtcSymbols.length; i++){
            currencyUtcSymbols[i].disabled = currencyUtcSymbols[i].id == currencyId;
        }
    }

    private getCurrencySymbolOrDefault(currencyId: number, defaultValue: string): string {
        const symbol: string | undefined = currencySymbols.find(currency => currency.id == currencyId)?.value;
        if (symbol !== undefined)
            return symbol;

        console.error('getCurrencySymbolOrDefault() error: could not find currency symbol in currencySymbols, currencyId=', currencyId, ', default value was returned');
        return defaultValue;
    }
}
